import React from "react";

const typeMap = {
    1: '30%',
    2: '60%'
}
export default function CarouselItem({obj}) {

  return (
      <img className="" style={{ marginTop: `${obj.offset}%`, width:typeMap[obj.type] ,aspectRatio: obj.aspect, height:undefined}} src={obj.imgUrl} alt={obj.imgTitle}></img>
  );
}